document.addEventListener('DOMContentLoaded', function () {
  const videoContainers = document.querySelectorAll('.cc-multi-column-videos .video-section');
  let firstVideoHasSound = false;

  // Configuration de la première vidéo en autoplay muted
  if (videoContainers.length > 0) {
    const firstVideo = videoContainers[0].querySelector('video');
    const firstPlayButton = videoContainers[0].querySelector('.card__video__play-icon');
    
    if (firstVideo) {
      firstVideo.muted = true;
      firstVideo.play();
      if (firstPlayButton) {
        firstPlayButton.classList.add('hidden');
      }
    }
  }

  videoContainers.forEach((container, index) => {
    container.addEventListener('click', function (event) {
      event.stopPropagation();
      
      const video = container.querySelector('video');
      const playButton = container.querySelector('.card__video__play-icon');

      // Gestion spéciale pour la première vidéo
      if (index === 0) {
        firstVideoHasSound = !firstVideoHasSound;
        
        video.currentTime = 0;
        
        if (firstVideoHasSound) {
          playButton.classList.add('hidden');
          setTimeout(function () {
            video.muted = false;
          }, 10);
        } else {
          playButton.classList.remove('hidden');
          setTimeout(function () {
            video.muted = true;
          }, 10);
        }
        
        video.play();

        const allVideos = document.querySelectorAll('.cc-multi-column-videos video');
        allVideos.forEach((v) => {
          if (v !== video) {
            v.pause();
            v.closest('.video-section').querySelector('.card__video__play-icon').classList.remove('hidden');
          }
        });

      } else {

        // Comportement normal pour les autres vidéos
        const allVideos = document.querySelectorAll('.cc-multi-column-videos video');
        allVideos.forEach((v) => {
          var firstVideo = document.querySelectorAll('.cc-multi-column-videos video')[0];
          if ( v == firstVideo ){
            if ( firstVideo.muted == false ){
              firstVideo.currentTime = 0;
              firstVideoHasSound = !firstVideoHasSound;
              setTimeout(function () {
                firstVideo.muted = true;
                document.querySelector('.cc-multi-column-videos .product-block:first-child .card__video__play-icon').classList.remove('hidden');
              }, 10);
            }
          } else if (v !== video) {
            v.pause();
            v.closest('.video-section').querySelector('.card__video__play-icon').classList.remove('hidden');
          }
        });

        if (video) {
          if (video.paused) {
            video.currentTime = 0;
            video.muted = false;
            video.play();
            playButton.classList.add('hidden');
          } else {
            video.pause();
            playButton.classList.remove('hidden');
          }
        }

      }

    });
  });

});